import JSDB from '../../fromKotlin/nk';

const API_BASE = 'https://nihulkav.online:4000';

export type AiKeyProvider = 'openai' | 'deepseek';

const keyCache: Partial<Record<AiKeyProvider, Promise<string>>> = {};

function getHeaders(): HeadersInit {
    const token = JSDB().getToken();
    return {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
    };
}

async function parseApiResponse(response: Response): Promise<any> {
    const json = await response.json().catch(() => ({}));
    if (!response.ok || json.status !== 'SUCCESS') {
        throw new Error(json?.status_msg || 'AI key API failed');
    }
    return json.data ?? {};
}

export async function getAiProviderKey(provider: AiKeyProvider): Promise<string> {
    if (!keyCache[provider]) {
        keyCache[provider] = fetch(`${API_BASE}/ai/api-key/${provider}`, {
            method: 'POST',
            headers: getHeaders(),
        })
            .then(parseApiResponse)
            .then((data) => {
                const apiKey = String(data?.api_key ?? '');
                if (!apiKey) throw new Error(`Missing ${provider} API key from server`);
                return apiKey;
            })
            .catch((error) => {
                delete keyCache[provider];
                throw error;
            });
    }
    return keyCache[provider]!;
}
